import React from 'react';
import { styled } from '@linaria/react';
import { useTopbar } from 'contexts/TopbarContext.jsx';
import useCallouts from 'hooks/useCallouts.jsx';

const Container = styled.div`
  position: relative;
  min-width: 0;
  min-height: 0;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TopbarGutter = () => {
  const { gutterContent } = useTopbar();
  const { callouts } = useCallouts({ type: 'gutterItem' });

  const content = [
    gutterContent,
    ...callouts
      .map((callout, index) => {
        const { content, group, type } = callout;
        return { ...content, key: `${group}-${type}-${index}` };
      }),
  ].filter(Boolean);

  if (!content.length) return null;
  return <Container>{content}</Container>;
};

export default TopbarGutter;
